export default __webpack_public_path__ + "static/media/h4.cc7801e7.jpg";